<script setup lang="ts">
import { useRouter } from "vue-router";

const props = defineProps<{
  sourceMateId: number;
  targetMateId: number;
}>();

const router = useRouter();

const goInteractionHistory = () => {
  router.push({
    name: "relationshipOther",
    query: {
      sourceId: props.sourceMateId,
      targetId: props.targetMateId,
    },
  });
};
</script>
<template>
  <button @click="goInteractionHistory">
    {{ $t("interactive.interactionHistory") }}
  </button>
</template>
